import { useFormContext, useWatch } from 'react-hook-form'
import get from 'lodash/get'
import { isTouchDevice } from '../utils/displayUtils'
import { shortTimeRangeString } from '../utils/dates'

import { SelectField as RawSelectField, ErrorLabel } from '../form'

import DropdownField from '../form/DropdownField'

const StyledSelectField = RawSelectField

const BookingTimeSlot = ({ time_slots: timeSlots }) => {
  const {
    register,
    setValue,
    control,
    formState: { errors, isSubmitted },
  } = useFormContext()

  const value = useWatch({ control, name: 'booking[time_slot]' })

  if (!(timeSlots && timeSlots.length > 0)) return null

  const error = get(errors, 'booking.time_slot')

  const writeSlot = (slotId) => {
    setValue('booking[time_slot]', slotId, {
      shouldDirty: true,
      shouldValidate: false,
    })
    const slot = timeSlots.find((t) => `${t.id}` === `${slotId}`)
    if (!slot) return
    setValue('booking[start_time]', slot.start, { shouldDirty: true })
    setValue('booking[end_time]', slot.end, { shouldDirty: true })
  }

  return (
    <div className="field" style={{ marginBottom: 16 }}>
      {isTouchDevice() ? (
        <StyledSelectField
          className="select-field"
          white
          isPlaceholder={!value}
          error={!!error && isSubmitted}
        >
          &nbsp;
          <select
            value={value || ''}
            onChange={(e) => writeSlot(e.target.value)}
            aria-label="Choose a time slot"
          >
            <option value="" disabled>
              Choose a time slot
            </option>
            {timeSlots.map(({ id, start, end }) => (
              <option key={id} value={id}>
                {shortTimeRangeString(start, end)}
              </option>
            ))}
          </select>
        </StyledSelectField>
      ) : (
        <DropdownField
          input={{ value, onChange: writeSlot }}
          meta={{
            error: error?.message,
            submitFailed: isSubmitted,
          }}
          placeholder="Choose a time slot"
          white
          items={timeSlots.map(({ start, end, ...rest }) => ({
            ...rest,
            label: shortTimeRangeString(start, end),
          }))}
        />
      )}

      {/* Hidden registered inputs so the values are part of native HTML form
       * POSTs. The visual selectors above write through setValue. */}
      <input
        type="hidden"
        {...register('booking[time_slot]', {
          validate: (v) => (v ? true : 'This field is required'),
        })}
      />
      <input type="hidden" {...register('booking[start_time]')} />
      <input type="hidden" {...register('booking[end_time]')} />

      {error && isSubmitted && (
        <ErrorLabel htmlFor="booking[time_slot]">{error.message}</ErrorLabel>
      )}
    </div>
  )
}

export default BookingTimeSlot
